import { render, staticRenderFns } from "./headernotification.vue?vue&type=template&id=79122016&scoped=true&lang=html"
import script from "./headernotification.vue?vue&type=script&lang=js"
export * from "./headernotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79122016",
  null
  
)

export default component.exports